module.exports = __webpack_public_path__ + "img/ícone-loja.44e78f15.svg";